/**
 * @generated SignedSource<<f6a2ea8bc67ecefd3264b483e6decc72>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
export type Currency = "AUD" | "CAD" | "CHF" | "DKK" | "EUR" | "GBP" | "JPY" | "MXN" | "NOK" | "SEK" | "USD" | "%future added value";
export type PriceType = "AUTOMATED_OFFER" | "NEGOTIATED" | "NET" | "RETAIL" | "WEEKLY_SALE" | "%future added value";
export type VerticalType = "art" | "fashion" | "furniture" | "jewelry" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type checkoutTransactionReducer_item$data = {
  readonly defaultSkuId: string | null;
  readonly hasUnlimitedQuantity: boolean | null;
  readonly isMultiSku: boolean;
  readonly pricing: {
    readonly prices: ReadonlyArray<{
      readonly amount: {
        readonly convertedAmountList: ReadonlyArray<{
          readonly amount: number | null;
          readonly currency: Currency | null;
        } | null> | null;
      } | null;
      readonly type: PriceType | null;
    } | null> | null;
    readonly totalAmount: {
      readonly conversionRateEvent: {
        readonly serviceId: string | null;
      } | null;
      readonly convertedAmountList: ReadonlyArray<{
        readonly amount: number | null;
        readonly currency: Currency | null;
      } | null> | null;
    } | null;
  } | null;
  readonly quantity: number | null;
  readonly serviceId: string | null;
  readonly vertical: VerticalType | null;
  readonly " $fragmentType": "checkoutTransactionReducer_item";
};
export type checkoutTransactionReducer_item$key = {
  readonly " $data"?: checkoutTransactionReducer_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"checkoutTransactionReducer_item">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "checkoutTransactionReducer_item"
};

(node as any).hash = "00e765a38dda252b6ece92c17efc7914";

export default node;
